<template>
  <div class="alert-message">
    <b-alert variant="danger" dismissible fade :show="showAlert" @dismissed="showAlert=false">
      <ul>
        <li v-for="item in items" :key="item.key">
          【{{ item.code }}】{{ item.message }}
        </li>
      </ul>
    </b-alert>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [],
      showAlert: false,
    };
  },
  created() {
    window.addEventListener('error', (event) => {
      this.items = event.error;
      this.showAlert = true;
    });
    window.addEventListener('unhandledrejection', (event) => {
      let details = '';
      let networkError = false;
      try {
        details = '[' + event.error.message + ']';
        if(event.error.message === 'Network Error') {
          networkError = true;
        }
      } catch(error) {
        // 何もしない
      }
      let message = '[ERR9999] エラーが発生しました。' + details;
      if(networkError) {
        message = '[ERR9998] 通信状況が不安定です(ログアウトします)' + details;
      } else{
        alert(message);
        this.$store.state.account = '';
        this.$store.state.name = '';
        this.$store.state.token = '';
        this.$store.state.role = '';
        this.$router.push('/login');
      }
    });
    window.addEventListener('hideAlert', (event) => {
      this.showAlert = false;
    });
  },
};
</script>

<style>
.alert-message {
  margin: 1rem 1rem 1rem 1rem;
}
.alert-message ul{
  margin-bottom: 0;
}
</style>
